<div class="h-100 chrome-reportpreview-overflow-fix">
    <ngx-ui-loader></ngx-ui-loader>
    <router-outlet></router-outlet>
</div>